import BusinessTripRequest from '@/components/business-trip/BusinessTripRequest'
import BusinessTripRequestDetail from '@/components/business-trip/BusinessTripRequestDetail'
import BusinessTripRequestNew from '@/components/business-trip/BusinessTripRequestNew'
import BusinessTripRequestExpense from '@/components/business-trip/BusinessTripRequestExpense'
import BusinessTripRequestExpenseNew from '@/components/business-trip/BusinessTripRequestExpenseNew'
import BusinessTripRequestExpenseDetail from '@/components/business-trip/BusinessTripRequestExpenseDetail'
import BusinessTripRequestEmployees from '@/components/business-trip/BusinessTripRequestEmployees'
import BusinessTripRequestEmployeeNew from '@/components/business-trip/BusinessTripRequestEmployeeNew'
import BusinessTripRequestEmployeeDetail from '@/components/business-trip/BusinessTripRequestEmployeeDetail'

const businessTripRequestRouter = [
  {
    path: 'business-trip-request',
    name: 'business-trip-request-list',
    component: BusinessTripRequest,
    props: true
  },
  {
    path: 'business-trip-request/new',
    name: 'business-trip-request-new',
    component: BusinessTripRequestNew,
    props: true
  },
  {
    path: 'business-trip-request/:id',
    component: BusinessTripRequestDetail,
    props: true,
    children: [
      {
        path: '',
        name: 'business-trip-request-detail',
        component: BusinessTripRequestEmployees,
        props: true
      }
    ]
  },
  {
    path: 'business-trip-request/:id/new-employee',
    name: 'business-trip-request-new-employee',
    component: BusinessTripRequestEmployeeNew,
    props: true
  },
  {
    path: 'business-trip-request/:id/:empid',
    name: 'business-trip-request-employee-detail',
    component: BusinessTripRequestEmployeeDetail,
    props: true
  },
  {
    path: 'business-trip-request/:id/:empid/expense',
    name: 'business-trip-request-expense',
    component: BusinessTripRequestExpense,
    props: true
  },
  {
    path: 'business-trip-request/:id/:empid/new-expense',
    name: 'business-trip-request-new-expense',
    component: BusinessTripRequestExpenseNew,
    props: true
  },
  {
    path: 'business-trip-request/:id/:empid/:expid',
    name: 'business-trip-request-expense-detail',
    component: BusinessTripRequestExpenseDetail,
    props: true
  }
]

export default businessTripRequestRouter



// WEBPACK FOOTER //
// ./src/router/BusinessTripRequestRouter.js